import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CTHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-783">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/2UJsQyfVLfGcwMijmKRdqM/AdobeStock_257206406-3.webp)'
    }} data-id="element-784" />
      <div className="absolute inset-0 bg-black/60" data-id="element-785" />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-786">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-787">
          <div className="mb-6" data-id="element-788">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-789">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-790">
                Treatments
              </a>{' '}
              / Body
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-791">
            Be COURAGEOUS
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-792">
            COOLTONE
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-793">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-794">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-795">
              When it comes to body contouring, CoolTone is hard to beat.{' '}
              <em data-id="element-796">
                "How can you say no to tens of thousands of abdominal crunches
                done for you by a machine in 20 minutes? Do I really need to say
                anything more?"
              </em>{' '}
              says Dr. Fiona.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-797">
              <em data-id="element-798">"This phenomenal machine is your gym on steroids!"</em> she
              explains.{' '}
              <em data-id="element-799">
                "It causes your own muscle fibers to contract without you doing
                a thing. It can be used on the abdomen and many other places
                while you just lay down and relax!"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-800">
              At Be CLINICAL, we can help you achieve the body you want, inside
              and out. CoolTone delivers transformative results for a more
              sculpted, defined look and a toned silhouette that turns back the
              clock on aging!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-801">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}